<template>
<v-card 
    class="elevation-2"
    v-if="value != null"
    style="margin-bottom: 15px"
>
    <v-card-text>
        <div style="display: flex; margin-bottom: 10px">
            <div>
                <v-icon style="margin-right: 5px">{{action_icon}}</v-icon>
            </div>

            <div style="font-weight: 700; font-size: 16px; margin-top: 1px">
                {{action_label}}: <span :style="label_style">{{value.label}}</span>
            </div>

        </div>
        
        <strong>When:</strong>
        <ul>
            <li
                v-for="(item, index) in value.conditions"
                :key="'cond_'+index"
            >
                {{item}}
            </li>
        </ul>
    </v-card-text>
</v-card>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            default: function() { return null; }
        },
    },

    computed: {
        action_icon() {
            if ( this.value == null ) return null;

            if ( this.value.action_type == 'email' ) return 'mdi-email-outline';
            if ( this.value.action_type == 'text' ) return 'mdi-message-text-outline';
            if ( this.value.action_type == 'webhook' ) return 'mdi-webhook';

            return null;
        },

        action_label() {
            if ( this.value == null ) return null;

            if ( this.value.action_type == 'email' ) return 'Send Email';
            if ( this.value.action_type == 'text' ) return 'Send Text Message';
            if ( this.value.action_type == 'webhook' ) return 'Fire Webhook';

            return null;
        },

        label_style() {
            if ( this.value == null ) return null;
            if ( this.value.action_type == 'webhook' ) return 'font-family: monospace;';
            return null;
        },
    },
}
</script>

<style lang="scss" scoped>

</style>